import React from 'react';
import { Input } from 'reactstrap';

export const defaultSelectOptions = [10, 25, 50, 100];

export default function SetLimitEntries({ onChange, value, selectOptions = defaultSelectOptions }) {
  return (
    <div className="select-limit">
      <Input
        type="select"
        onChange={e => onChange(e.currentTarget.value)}
        defaultValue={value}
        style={{ padding: '0px 0px 0px 7px' }}
      >
        {selectOptions.map(el => (
          <option key={el} value={el}>
            {el} Rows
          </option>
        ))}
      </Input>
    </div>
  );
}
